// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.camera-preview[data-v-08bed547] {\n  border-radius: 8px;\n  background: #000;\n}\n.camera-plus-btn[data-v-08bed547] {\n  margin-top: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
